import type { O5AwsDeployerV1ClusterKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const O5_CLUSTER_BASE_PATH = getResolvedPath('/tech-ops/cluster');

export const getO5ClusterPath: EntityPathBuilder<O5AwsDeployerV1ClusterKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return O5_CLUSTER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.clusterId) {
        return undefined;
      }

      return getResolvedPath(`${O5_CLUSTER_BASE_PATH}/$clusterId`, context?.keys);
    }
  }
};

export function getO5ClusterDetailPath(clusterId: string | undefined) {
  if (!clusterId) {
    return undefined;
  }

  return getO5ClusterPath({ kind: 'detail', keys: { clusterId } });
}
